import type { ReactNode } from 'react';

import type { ButtonOrLinkDataProps } from 'components/ButtonOrLink/ButtonOrLinkData';
import { Icon } from 'components/Icon/Icon';
import { Tag } from 'components/Tag/Tag';
import { useI18n } from 'i18n/hooks/useI18n';

import {
  PostAListingPageButtonOrLink,
  PostAListingPageButtonText,
} from './PostAListingPageButton.styled';

type Props = ButtonOrLinkDataProps<{
  qaId: string;
  children: ReactNode;
  fromVM: boolean;
}>;

export function PostAListingPageButton({
  children,
  qaId,
  fromVM,
  ...otherProps
}: Props) {
  const { i18n } = useI18n();

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <PostAListingPageButtonOrLink {...otherProps} qaId={qaId}>
      <PostAListingPageButtonText>
        {children}

        {fromVM && <Tag size="medium">{i18n('Imported Organization')}</Tag>}
      </PostAListingPageButtonText>

      <Icon name="chevron-right" size={18} />
    </PostAListingPageButtonOrLink>
  );
}
